export default "{\n    \"defaultMessage\": \"Oops... something went wrong\",\n    \"retryButtonLabel\": \"Retry\"\n}\n"